import type { ReactNode } from "react";
import cx from "ui/cx";
import InputLabel from "ui/forms/InputLabel";
import IconInfoLine from "ui/icons/IconInfoLine";
import { wrapWithTooltip } from "ui/popovers/Tooltip";
import styles from "./InputGroup.module.scss";

export interface InputGroupProps {
  labelText?: ReactNode;
  labelLink?: ReactNode;
  tooltip?: ReactNode;
  className?: string;
  children: ReactNode;
  errorText?: string;
  required?: boolean;
  id?: string;
}

export default function InputGroup({
  labelText,
  labelLink,
  tooltip,
  className,
  children,
  errorText,
  required,
  id,
}: InputGroupProps) {
  return (
    <div className={cx(styles.wrapper, className)}>
      {labelText && (
        <label htmlFor={id} className="label">
          <InputLabel text={labelText} required={required} className={styles.label} />
          {labelLink}
          {tooltip && wrapWithTooltip(<IconInfoLine className="tooltip" />, tooltip)}
        </label>
      )}
      <div>{children}</div>
      {errorText && <div className="error-text">{errorText}</div>}
    </div>
  );
}
